
import store from "@/store";
import router from "@/router";
import storeInstance from "@/store";
import { onMounted } from "@vue/composition-api";
import { actionWithToast } from "@/helpers/actionWithToast";
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  onMounted(async () => {
    if (store.getters.isUserLogin) {
      try {
        await actionWithToast(storeInstance.dispatch("OAUTH2_LOGIN", router.currentRoute.fullPath), "common.auth.oauth2.messages");
      } catch (e) {
        await router.push({
          name: "dashboard"
        });
      }
    } else {
      await router.push({
        name: "auth:signIn"
      });
    }
  });
  return {};
};
export default __sfc_main;
